export function replaceCollectionItemsWithChildren(elements: HTMLCollection): void {
    while (elements.length > 0) {
        const element = elements[0];
        element.replaceWith(...element.childNodes);
    }
}
